import { countries, TCountryCode } from "countries-list";

/**
 * Get the primary currency to a country
 * @param countryCode Country ISO 3166-1 alfa-2 code (fx "DK", "DE", "US")
 * @returns Country code (ISO 4217), fx "DKK"
 */
export function getPrimaryCurrency(countryCode?: string): string {
    const country = countryCode ? countries[countryCode as TCountryCode] : undefined;
    if (!country || !country.currency) {
        console.error(`No currency found for country code: ${countryCode}`);
        return "N/A";
    }
    const primaryCurrency = country.currency[0].trim();
    if (!/^[A-Z]{3}$/.test(primaryCurrency)) {
        console.error(`Invalid currency code format: ${primaryCurrency}`);
        return "N/A";
    }
    return primaryCurrency;
}
